<template>
  <div
    class="d-flex flex-column h-100"
    :class="{ 'flex-column-reverse': mobile }"
    style="overflow: hidden"
  >
    <div class="">
      <div>
        <PlayerView :volumeLevel="this.volumeLevel" />
      </div>

      <!-- hide desktop menu when mobile -->
      <div class="hidden-sm-and-down">
        <NavTopView class="font-tw" />
      </div>
    </div>

    <div class="d-flex gradient-background-1">
      <!-- size difference in mobile and desktop -->
      <MainView
        :style="{
          height: !mobile ? 'calc(100dvh - 120px)' : 'calc(100dvh - 70px)',
        }"
      />
    </div>

    <!-- mobile navTopview -->
    <v-slide-y-reverse-transition>
      <div
        v-if="mobile && this.mobileMenuOpen"
        class="bg-white"
        style="position: fixed; height: calc(100dvh - 70px); top: 0; width: 100%; z-index: 100"
      >
        <NavTopView class="font-tw"></NavTopView>
      </div>
    </v-slide-y-reverse-transition>
  </div>

</template>
<script>
import PlayerView from "@/views/PlayerView.vue";
import NavTopView from "@/views/NavTopView.vue";
import MainView from "@/views/MainView.vue";

export default {
  inject: ["eventBus", "mobile"],
  data() {
    return {
      mobileMenuOpen: false,
      volumeLevel: null,
    };
  },
  created() {
    this.eventBus.on("mobile-menu-open", (value) => {
      this.mobileMenuOpen = value;
    });

    if (this.volumeLevel == null) {
      this.volumeLevel = 218;
    }
    this.eventBus.on("volume-value", (value) => {
      this.volumeLevel = value;
    });
  },
  components: {
    PlayerView,
    NavTopView,
    MainView,
  },
};
</script>


